import { useEffect, useState } from "react";

import MelhousNotice from "../Components/MelhousNotice";
import MelhousPage from "../Components/MelhousPage";
import QrCard from "../Components/QrCard";
import QrMissingLink from "../Components/QrMissingLink";
import { fetchMelhous } from "../helpers/hotelDefaults";
import { getQrBase } from "../helpers/qr";
import useOpenView from "../helpers/useOpenView";
import { QR_FIELDS, QR_LINKS, VIEW_QR } from "../constants";

function MelhousQr() {
  const onOpen = useOpenView();
  const [melhous, setMelhous] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      const result = await fetchMelhous(QR_FIELDS);
      if (!cancelled) setMelhous(result);
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const linkMelhous = melhous?.link_melhous;

  return (
    <MelhousPage view={VIEW_QR}>
      {melhous !== undefined && !linkMelhous && (
        <div className="p-3 lg:p-4">
          <QrMissingLink onOpen={onOpen} />
        </div>
      )}
      {linkMelhous && (
        <div className="space-y-4 p-3 lg:p-4">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
            {QR_LINKS.map((qr) => (
              <QrCard
                key={qr.path}
                qr={qr}
                url={`${getQrBase(linkMelhous)}${qr.path}`}
              />
            ))}
          </div>
          <MelhousNotice text="melhous.dash.qr.table_notice" />
        </div>
      )}
    </MelhousPage>
  );
}

export default MelhousQr;
